class Auth{
    constructor(){
        this.authenticated = localStorage.getItem('authenticated',false);
    }

    login(cb){
        // in actual store jwt token here
    
        localStorage.setItem('authenticated',true);
        this.authenticated = true;
        cb();
    }

    logout(cb){
        localStorage.setItem('authenticated',false);
        this.authenticated = false;
        cb();
    }

    isAuthenticated(){
        return this.authenticated;
    }

}

export default new Auth();


// WEBPACK FOOTER //
// ./src/auth.js